export default "__VITE_ASSET__J9e8EPqY__"